import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceintitaniumbuisnesspark() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Titanium Business Park Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Titanium Business Park Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Titanium Business Park Ahmedabad, catering to the transportation needs of corporate offices, IT firms, and business centers located in the complex. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver smooth and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited delivers a premium and dependable corporate travel experience for businesses operating in and around Titanium Business Park Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Titanium Business Park Employee Cab Ahmedabad",
    "description": "Titanium Business Park Employee Cab Ahmedabad offers dedicated transportation services for employees working at Titanium Business Park. The service includes a fleet of modern vehicles, experienced chauffeurs, and real-time tracking, ensuring timely and comfortable commuting for all employees across various shifts."
  },
  {
    "name": "Corporate Shuttle Titanium Park Ahmedabad",
    "description": "Corporate Shuttle Titanium Park Ahmedabad provides high-capacity shuttle services for businesses with a large workforce in Titanium Park. With AC minibuses and optimized routes, the service ensures efficient, safe, and timely transport for staff, including multi-shift operations and GPS-enabled route monitoring."
  },
  {
    "name": "Business Cab Titanium Business Park Ahmedabad",
    "description": "Business Cab Titanium Business Park Ahmedabad delivers premium transportation solutions for business executives and professionals. The fleet includes luxury sedans and SUVs, driven by professional chauffeurs, ensuring a refined and comfortable experience for corporate meetings, airport transfers, and client visits."
  },
  {
    "name": "Office Cab Titanium Park Ahmedabad",
    "description": "Office Cab Titanium Park Ahmedabad provides structured, reliable transport services for employees commuting to and from Titanium Park. With pre-planned routes, professional chauffeurs, and real-time tracking, it ensures a seamless and safe commuting experience for all staff, suited for daily office hours and flexible shifts."
  },
  {
    "name": "Staff Pickup Drop Titanium Business Park Ahmedabad",
    "description": "Staff Pickup Drop Titanium Business Park Ahmedabad offers convenient pick-up and drop-off services for employees working in Titanium Business Park. With fixed routes, safety protocols, and efficient scheduling, this service ensures a hassle-free and punctual commute for all workforce categories."
  },
  {
    "name": "Monthly Cab Titanium Park Ahmedabad",
    "description": "Monthly Cab Titanium Park Ahmedabad offers long-term transport solutions for companies requiring regular employee transportation to and from Titanium Park. The service includes a managed fleet, vehicle maintenance, route optimization, and dedicated support, ensuring consistent and reliable service for employees on a monthly contract basis."
  },
  {
    "name": "Affordable Cab Titanium Business Park Ahmedabad",
    "description": "Affordable Cab Titanium Business Park Ahmedabad provides cost-effective transportation options without compromising on reliability or safety. The service is designed for startups, SMEs, and mid-sized businesses requiring dependable employee transportation at budget-friendly rates."
  },
  {
    "name": "Best Corporate Cab Titanium Park Ahmedabad",
    "description": "Best Corporate Cab Titanium Park Ahmedabad offers top-tier transportation services with premium vehicles, verified chauffeurs, and exceptional service standards. Ideal for senior executives and business visitors, the service ensures comfort, punctuality, and professionalism in every journey."
  },
  {
    "name": "Outstation Cab Titanium Business Park Ahmedabad",
    "description": "Outstation Cab Titanium Business Park Ahmedabad provides reliable and safe long-distance travel options for business trips, client visits, and corporate events. With a fleet of comfortable sedans and SUVs, experienced chauffeurs, and route planning, the service ensures hassle-free outstation travel for professionals."
  },
  {
    "name": "Sedan Cab Titanium Park Ahmedabad",
    "description": "Sedan Cab Titanium Park Ahmedabad offers luxury sedans for business professionals requiring comfortable and discreet travel. Whether for corporate meetings, airport transfers, or everyday office commutes, the sedans are equipped with plush interiors, professional drivers, and efficient route management to ensure a smooth journey."
  },
  {
    "name": "SUV Cab Titanium Business Park Ahmedabad",
    "description": "SUV Cab Titanium Business Park Ahmedabad offers spacious and comfortable SUVs for group travel, executive transport, and outstation trips. The service prioritizes safety, comfort, and reliability, ensuring that senior executives, clients, and teams are transported with the utmost care and professionalism."
  },
  {
    "name": "Company Staff Transport Titanium Park Ahmedabad",
    "description": "Company Staff Transport Titanium Park Ahmedabad offers a comprehensive transport solution for businesses located in Titanium Park. The service ensures consistent and dependable daily employee movement, including vehicle management, route optimization, and real-time tracking for enhanced employee mobility and safety."
  },
  {
    "name": "Employee Mobility Titanium Ahmedabad",
    "description": "Employee Mobility Titanium Ahmedabad ensures seamless employee commuting with tech-enabled routing, real-time vehicle tracking, and a managed fleet of vehicles. The service provides scalable solutions tailored to meet the mobility needs of companies in Titanium Park, including shift-based operations and peak-hour transport."
  },
  {
    "name": "Corporate Fleet Titanium Business Park Ahmedabad",
    "description": "Corporate Fleet Titanium Business Park Ahmedabad offers fleet management solutions for companies needing outsourced employee transport services. The service includes vehicle maintenance, driver management, real-time tracking, and customized transport plans to ensure efficiency, safety, and comfort for businesses in Titanium Business Park."
  },
  {
    "name": "IT Corporate Cab Titanium Park Ahmedabad",
    "description": "IT Corporate Cab Titanium Park Ahmedabad provides specialized transport services for employees, executives, and visitors traveling to Titanium Park. The service includes a fleet of vehicles, including sedans and SUVs, equipped with the latest technology for route optimization, real-time tracking, and enhanced safety features, ensuring reliable and comfortable transport."
  }
],

"tableData": [
  ["Titanium Business Park Employee Cab Ahmedabad", "Corporate Shuttle Titanium Park Ahmedabad"],
  ["Business Cab Titanium Business Park Ahmedabad", "Office Cab Titanium Park Ahmedabad"],
  ["Staff Pickup Drop Titanium Business Park Ahmedabad", "Monthly Cab Titanium Park Ahmedabad"],
  ["Affordable Cab Titanium Business Park Ahmedabad", "Best Corporate Cab Titanium Park Ahmedabad"],
  ["Outstation Cab Titanium Business Park Ahmedabad", "Sedan Cab Titanium Park Ahmedabad"],
  ["SUV Cab Titanium Business Park Ahmedabad", "Company Staff Transport Titanium Park Ahmedabad"],
  ["Employee Mobility Titanium Ahmedabad", "Corporate Fleet Titanium Business Park Ahmedabad"],
  ["IT Corporate Cab Titanium Park Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Titanium Business Park Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Titanium Business Park Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the IT and business hub."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Titanium Business Park and nearby corporate offices, helping professionals reach workplaces and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs offer safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Titanium Business Park."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate cab rental plans to meet the commuting requirements of companies and employees in Titanium Business Park Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking process and reliable coordination, making employee transportation hassle-free."
  }
]





































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Titanium Business Park, Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and offices in Titanium Business Park, Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Titanium Business Park?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and full fleet management for corporate clients.',
  },
  {
    question: 'Do you support daily employee commute services in Titanium Business Park?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Titanium Business Park?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Titanium Business Park?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for Titanium Business Park offices?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Titanium Business Park?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Very reliable corporate cab service for our Titanium Business Park office. Vehicles are clean and drivers are always punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Mehta',
    feedback: 'Excellent transportation partner. Our employees appreciate the smooth, safe, and timely commute services every day.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Titanium Business Park Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-titanium-business-park.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in Titanium Business Park Ahmedabad, including employee transportation, corporate shuttle, office cab services, staff pickup & drop, monthly corporate cab plans, business cabs, outstation trips, IT corporate cab services, sedan & SUV cabs, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-titanium-business-park-ahmedabad"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Titanium Business Park Ahmedabad | Employee & IT Corporate Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Titanium Business Park Ahmedabad including employee cabs, corporate shuttle, office cab services, staff pickup & drop, monthly corporate cab rentals, business cabs, outstation travel, IT corporate cab services, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Titanium Business Park Employee Cab Ahmedabad, Corporate Shuttle Titanium Park Ahmedabad, Business Cab Titanium Business Park Ahmedabad, Office Cab Titanium Park Ahmedabad, Staff Pickup Drop Titanium Business Park Ahmedabad, Monthly Cab Titanium Park Ahmedabad, Affordable Cab Titanium Business Park Ahmedabad, Best Corporate Cab Titanium Park Ahmedabad, Outstation Cab Titanium Business Park Ahmedabad, Sedan Cab Titanium Park Ahmedabad, SUV Cab Titanium Business Park Ahmedabad, Company Staff Transport Titanium Park Ahmedabad, Employee Mobility Titanium Ahmedabad, Corporate Fleet Titanium Business Park Ahmedabad, IT Corporate Cab Titanium Park Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceintitaniumbuisnesspark;